module.exports = __webpack_public_path__ + "img/Cube.f40bbe2d.png";